import { Factory } from '../Factory';

import IWindowService = angular.IWindowService;

export class TrackService implements IService {
  private window: IWindowService;
  private routeParams;
  private auditLogService: any;

  constructor($window: IWindowService, $routeParams, auditLogService: any) {
    this.window = $window;
    this.routeParams = $routeParams;
    this.auditLogService = auditLogService;
  }

  private static CleanText(text) {
    if (!text) text = "";
    return text.replace(/(\r\n|\n|\r)/gm, ' ').replace(/\s{2,}/g, ' ').trim().toLowerCase();
  }

  // Shared between buttons and anchors
  public ClickHandler(trackString, element) {
    if (!trackString) {
      // We don't want badge text
      const text = $(element)
        .clone()    //clone the element
        .children(".badge") //select all with the badge
        .remove()   //remove all the children
        .end()  //again go back to selected element
        .text();

      trackString = TrackService.CleanText(text);
      if (!trackString) trackString = TrackService.CleanText(element.attr('uib-tooltip'));
    }

    if (!trackString) {
      // Dont log this if it's still empty
      return;
    }

    // Narrow down the navigational links
    const navParent = element.parent().parent();

    if (navParent.is('.nav-tabs')) {
      trackString += " tab";
    } else if (navParent.is('.nav')) {
      trackString += " nav";
    } else if (navParent.is('.breadcrumb')) {
      trackString += " crumb";
    }

    this.TrackEvent(trackString, "clicked");
  }

  public TrackPageView(url) {
    this.window.gtag('config', 'UA-35145227-1', {
      'page_path': url
    });

    if (this.routeParams.projectId) {
      this.auditLogService.Audit(this.routeParams.projectId, "View Page", {url});
    }
  }

  public TrackEvent(category: string, action: string, opt_label?: string, opt_value?: any, opt_noninteraction?: any) {
    console.log("Tracking event: " + category + ":" + action);
    this.window.gtag('event', action, {
      'event_category': category,
      'event_label': opt_label,
      'value': opt_value,
      'non_interaction': opt_noninteraction
    });
  }

  public TrackBingEvent(eventName: string, category: string, label: string) {
    console.log("Tracking bing event: " + eventName + ", " + category + ", " + label);
    this.window.uetq = this.window.uetq || [];
    this.window.uetq.push('event', eventName, {event_category: category, event_label: label, event_value: 0});
  }

  public TrackTrialConversion() {
    console.log("Tracking trial conversion");
    this.TrackEvent("sign up", "verify email");
    this.TrackBingEvent("Sign-Up", "Trial", "Bing");
  }

  public TrackCreditCardEnteredConversion() {
    console.log("Tracking credit card entered conversion");
    this.TrackEvent("credit card", "entered");
    this.TrackBingEvent("Information Entered", "Credit Card", "Bing");
  }
}

frontendApp.factory("TrackService", ["$window", "$routeParams", "AuditLogService", Factory.Create(TrackService)]);
